import { useState } from "react";

export function useSelection(rows) {
  const [selected, setSelected] = useState([]);

  const checkSelected = (row) => {
    return selected.indexOf(row.id) !== -1;
  };

  const onSelectAll = (checked) => {
    if (checked) {
      const allRowIds = rows.map((ac) => {
        return ac.id;
      });
      setSelected(allRowIds);
      return;
    }
    setSelected([]);
  };

  const onSelectRow = ({ id }) => {
    const selectedIndex = selected.indexOf(id);

    if (checkSelected({ id })) {
      setSelected((prev) => {
        const newSelected = [...prev];
        newSelected.splice(selectedIndex, 1);
        return newSelected;
      });
      return;
    }
    setSelected((prev) => {
      return [...prev, id];
    });
  };

  const clearSelection = () => {
    setSelected([]);
  };

  return { selected, checkSelected, onSelectAll, onSelectRow, clearSelection };
}

export default useSelection;
